import { render, staticRenderFns } from "./promotion-preview.component.vue?vue&type=template&id=f426d3fc&scoped=true"
import script from "./promotion-preview.component.vue?vue&type=script&lang=ts"
export * from "./promotion-preview.component.vue?vue&type=script&lang=ts"
import style0 from "./promotion-preview.component.vue?vue&type=style&index=0&id=f426d3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f426d3fc",
  null
  
)

export default component.exports